import { CreateEscrowSettingsRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateCreateEscrowSettings = makeValidator({
  FieldParser: CreateEscrowSettingsRow,
});
